import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { useAppStore } from 'store/modules/appStore';
import { useUserStore } from 'store/modules/userStore';
import HiCache from 'utils/cache';
const theme = import.meta.env.VITE_THEME || 'green'
const registerTheme = theme === 'green' ? '' : `_${theme}`;
const routes: RouteRecordRaw[] = [
    {
        path: '/',
        component: () => import('@/components/xb-page/xb-page.vue'),
        meta: {
            keepAlive: true, // 路由缓存
        },
        children: [
            {
                path: '/',
                name: 'index',
                component: () => import('@/views/index/index.vue'),
                meta: {
                    keepAlive: true, // 路由缓存
                },
            },
            {
                path: '/promo',
                name: 'promo',
                component: () => import('@/views/promo/promo.vue'),
                meta: {
                    keepAlive: true, // 路由缓存
                },
            },
            {
                path: '/promotion',
                name: 'promotion',
                component: () => import('@/views/earn/earn.vue'),
                meta: {
                    keepAlive: true, // 路由缓存
                },
            },
            {
                path: '/account',
                name: 'account',
                component: () => import('@/views/account/account.vue'),
                meta: {
                    keepAlive: true, // 路由缓存
                },
            },
            {
                path: '/roulette',
                name: 'roulette',
                component: () => import('@/views/roulette/roulette_page.vue'),
                meta: {
                    keepAlive: true, // 路由缓存
                },
            },
        ],
    },
    {
        path: '/roulette/details',
        name: 'rouletteDetails',
        component: () => import('@/views/roulette/roulette_details_page.vue'),
        meta: {
            keepAlive: true, // 路由缓存
        },
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/login.vue'),
    },
    {
        path: '/register',
        name: 'register',
        component: () => import(`@/views/register/register.vue`),
        // component: () => import(`@/views/register/register${registerTheme}.vue`),
    },
    {
        path: '/activityDetail',
        name: 'activityDetail',
        component: () => import('@/views/promo/promo-detail.vue'),
    },
    {
        path: '/activityRecord',
        name: 'activityRecord',
        component: () => import('@/views/promo/promo-records.vue'),
    },
    {
        path: '/moreGameList',
        name: 'moreGameList',
        component: () => import('@/views/moreGameList/moreGameList.vue'),
    },
    {
        path: '/gameDetail',
        name: 'gameDetail',
        component: () => import('@/views/gameDetail/gameDetail.vue'),
    },
    {
        path: '/gameDetailV3',
        name: 'gameDetailV3',
        component: () => import('@/views/gameDetailV3/gameDetailV3.vue'),
    },
    {
        path: '/deposit',
        name: 'deposit',
        component: () => import('@/views/deposit/deposit.vue'),
    },
    {
        path: '/withdraw',
        name: 'withdraw',
        component: () => import('@/views/withdraw/withdraw.vue'),
    },
    {
        path: '/bindCard',
        name: 'bindCard',
        component: () => import('@/views/bindCard/bindCard.vue'),
    },
    {
        path: '/liveMobile',
        name: 'liveMobile',
        component: () => import('@/views/liveMobile/render.vue'),
    },
    {
        path: '/myInfo',
        name: 'myInfo',
        component: () => import('@/views/myInfo/myInfo.vue'),
    },
    {
        path: '/selectAvatar',
        name: 'selectAvatar',
        component: () => import('@/views/selectAvatar/selectAvatar.vue'),
    },
    {
        path: '/balanceDetail',
        name: 'balanceDetail',
        component: () => import('@/views/balanceDetail/balanceDetail.vue'),
    },
    {
        path: '/betRecord',
        name: 'betRecord',
        component: () => import('@/views/betRecord/betRecord.vue'),
    },
    {
        path: '/webView',
        name: 'webView',
        component: () => import('@/views/webView/webView.vue'),
    },
    {
        path: '/recoveryMoney',
        name: 'recoveryMoney',
        component: () => import('@/views/recoveryMoney/recoveryMoney.vue'),
    },
    {
        path: '/depositRoulette',
        name: 'depositRoulette',
        component: () => import('@/views/depositRoulette/depositRoulette.tsx'),
    },
    {
        path: '/newRoulette',
        name: 'newRoulette',
        component: () => import('@/views/depositRoulette/depositRoulette.tsx'),
    },
    {
        path: '/depositRouletteRules',
        name: 'depositRouletteRules',
        component: () => import('@/views/depositRouletteRules/depositRouletteRules.vue'),
    },
    {
        path: '/depositRouletteHistory',
        name: 'depositRouletteHistory',
        component: () => import('@/views/depositRouletteHistory/depositRouletteHistory.vue'),
    },
    {
        path: '/invite',
        name: 'invite',
        component: () => import('@/views/invite/invite.vue'),
    },
    {
        path: '/rankingPage',
        name: 'rankingPage',
        component: () => import('@/views/ranking/ranking.vue'),
    },
    {
        path: '/rulesPage',
        name: 'rulesPage',
        component: () => import('@/views/agentRules/rules_page.vue'),
    },
    {
        path: '/rulesPage2',
        name: 'rulesPage2',
        component: () => import('@/views/agentRules/rules_page2.vue'),
    },
    {
        path: '/userBalance',
        name: 'userBalance',
        component: () => import('@/views/userBalance/userBalance.vue'),
    },
    {
        path: '/historicalDetails',
        name: 'historicalDetails',
        component: () => import('@/views/historicalDetails/historicalDetails.vue'),
    },
    {
        path: '/vip',
        name: 'vip',
        component: () => import('@/views/vip/vip_page.vue'),
    },
    {
        path: '/myBonus',
        name: 'myBonus',
        component: () => import('@/views/vip/my_bonus.vue'),
    },
    {
        path: '/subordinate',
        name: 'subordinate',
        component: () => import('@/views/subordinate/subordinate.vue'),
    },
    {
        path: '/message',
        name: 'message',
        component: () => import('@/views/message/message_page.vue'),
    },
    {
        path: '/messageDetail',
        name: 'messageDetail',
        component: () => import('@/views/message/message_detail_page.vue'),
    },

    // 移动端win
    {
        path: '/gameMobileWin',
        name: 'gameMobileWin',
        component: async () => await import(/* webpackChunkName: "gameMobileWin" */ '@/views/gameMobileWin/render.vue'),
    },
    {
        path: '/gameMobile5d',
        name: 'gameMobile5d',
        component: async () => await import(/* webpackChunkName: "gameMobile5d" */ '@/views/gameMobile5d/render.vue'),
    },
    {
        path: '/gameMobileColorLand',
        name: 'gameMobileColorLand',
        component: async () => await import(/* webpackChunkName: "gameMobileColorLand" */ '@/views/gameMobileColorLand/render.vue'),
    },
    {
        path: '/gameMobileTRXWin',
        name: 'gameMobileTRXWin',
        component: async () => await import(/* webpackChunkName: "gameMobileTRXWin" */ '@/views/gameMobileTRXWin/render.vue'),
    },
    {
        path: '/gameMobileNotice',
        name: 'gameMobileNotice',
        component: async () => await import(/* webpackChunkName: "gameMobileNotice" */ '@/views/gameMobileNotice/render.vue'),
    },
    {
        path: '/misteriosoBouns',
        name: 'misteriosoBouns',
        component: async () => await import(/* webpackChunkName: "misteriosoBouns" */ '@/views/misteriosoBouns/misteriosoBouns.vue'),
    },
    {
        path: '/levelBenefits',
        name: 'levelBenefits',
        component: async () => await import(/* webpackChunkName: "levelBenefits" */ '@/views/levelBenefits/levelBenefits.vue'),
    },
    {
        path: '/signInBonus',
        name: 'signInBonus',
        component: async () => await import(/* webpackChunkName: "signInBonus" */ '@/views/signInBonus/signInBonus.vue'),
    },
    {
        path: '/treasureChest',
        name: 'treasureChest',
        component: async () => await import(/* webpackChunkName: "treasureChest" */ '@/views/treasureChest/treasure_chest.vue'),
    },
    {
        path: '/home',
        name: 'home',
        component: async () => await import(/* webpackChunkName: "home" */ '@/views/home/home.vue'),
    },
    {
        path: '/paramsQuery',
        name: 'paramsQuery',
        component: () => import('@/views/paramsQuery/paramsQuery.vue'),
    },
    {
        path: '/paySuccess',
        name: 'paySuccess',
        component: () => import('@/views/paySuccess/paySuccess.vue'),
    },
    {
        path: '/gameDay',
        name: 'gameDay',
        component: () => import('@/views/gameDay/gameDay.vue'),
    },
    {
        path: '/gameWeek',
        name: 'gameWeek',
        component: () => import('@/views/gameWeek/gameWeek.vue'),
    },
    {
        path: '/depositWallet',
        name: 'depositWallet',
        component: () => import('@/views/deposit/deposit_wallet.vue'),
    },
    {
        path: '/database',
        name: 'database',
        component: () => import('@/views/database/database.vue'),
    },
    {
        path: '/profit',
        name: 'profit',
        component: () => import('@/views/profit/profit.vue'),
    },
    {
        path: '/callback',
        name: 'callback',
        component: () => import('@/views/callback/callback.vue'),
    },
    {
        path: '/giftCenter',
        name: 'giftCenter',
        component: () => import('@/views/giftCenter/giftCenter.vue'),
    },
    {
        path: '/gametrack',
        name: 'gametrack',
        component: () => import('@/views/gametrack/gametrack.vue'),
    },
    {
        path: '/searchgame',
        name: 'searchgame',
        component: () => import('@/views/searchgame/searchgame.vue'),
        meta: {
            keepAlive: true,
        },
    },
    {
        path: '/returnRecharge',
        name: 'returnRecharge',
        component: () => import('@/views/returnRecharge/returnRecharge.vue'),
    },
    {
        path: '/returnTotalRecharge',
        name: 'returnTotalRecharge',
        component: () => import('@/views/returnRecharge/returnTotalRecharge.vue'),
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        // 始终滚动到顶部
        return { top: 0 };
    },
});

// 获取查询参数的函数
function getQueryString(name) {
    const params = new URLSearchParams(window.location.search);
    return params.get(name);
}

// 白名单路由列表
const ignoreRouteName = [
    'index',
    'login',
    'promo',
    'gameDay',
    'gameWeek',
    'activityDetail',
    'misteriosoBouns',
    'levelBenefits',
    'register',
    'moreGameList',
    'gameDetail',
    'gameDetailV3',
    'liveMobile',
    'webView',
    'home',
    'paramsQuery',
    'paySuccess',
    'signInBonus',
    'database',
    'callback',
    'gametrack',
    'searchgame',
    'returnRecharge',
    'returnTotalRecharge',
];

router.beforeEach((to, from, next) => {
    // 优先判断是否是支付成功页面
    if (to.name === 'paySuccess') {
        next();
        return;
    }

    const appStore = useAppStore();
    const userStore = useUserStore();
    const isLogin = userStore.IsLogin;

    // 检查路由对象的name属性是否存在
    const hasName = typeof to.name !== 'undefined';

    // 判断是否是登录或注册页面
    to.query.code && HiCache.setCache('spreaderId', to.query.code);

    // 如果缓存里面的spreaderId=bank 就删除
    if (HiCache.getCache('spreaderId') === 'bank' || HiCache.getCache('spreaderId') === 'wattle') {
        HiCache.deleteCache('spreaderId');
        HiCache.deleteCache('app_code');
    }

    // sdmode 路由处理逻辑
    // const sdmode = getQueryString('sdmode');
    // const sdmode = to.query.sdmode;
    // console.log(sdmode, from.path, '==========sdmode');
    // // if (sdmode) {
    // //     localStorage.setItem('sdmode', sdmode.toString());
    // // }
    // // 只在初始路由或路由发生实质性变化时进行重定向
    // if (sdmode && from.path === '/') {
    //     if (sdmode === '2' && to.path !== '/') {
    //         next({
    //             path: '/',
    //             query: to.query,
    //         });
    //         return;
    //     } else if (sdmode !== '2' && to.path !== '/home') {
    //         next({
    //             path: '/home',
    //             query: to.query,
    //         });
    //         return;
    //     }
    // }

    // 已登录用户不允许访问登录和注册页面
    if (isLogin && (to.name === 'login' || to.name === 'register')) {
        next({ path: '/', query: to.query });
        return;
    }
    console.log(to.name, '==========to.name');
    // 原有的路由判断逻辑
    if ((!hasName || !ignoreRouteName.includes(to.name.toString())) && !isLogin) {
        next({
            path: '/login',
            query: to.query, // 保持原有参数
        });
    } else if (isLogin) {
        next();
    } else {
        if (hasName && ignoreRouteName.includes(to.name.toString())) {
            next();
        } else {
            console.log('未登录');
            next(from.path);
        }
    }
});

// 路由守卫
// router.beforeEach((to, from, next) => {
//     // 优先判断是否是支付成功页面
//     if (to.name === 'paySuccess') {
//         next();
//         return;
//     }

//     const appStore = useAppStore();
//     const userStore = useUserStore();
//     const isLogin = userStore.IsLogin;

//     // 从地址栏获取 sdmode 和 code 参数
//     const sdmode = getQueryString('sdmode');
//     const code = to.query.code;

//     // 存储 code 参数
//     if (code) {
//         HiCache.setCache('spreaderId', code);
//     }

//     // 判断是否是白名单路由
//     const isIgnoreRoute = to.name && ignoreRouteName.includes(to.name.toString());

//     // **特殊情况处理**：如果在 /home 页面且 sdmode=2，重定向到 /
//     if (to.path === '/home' && sdmode === '2') {
//         next({
//             path: '/',
//             query: to.query, // 携带原有参数
//         });
//         return;
//     }

//     // 1. 优先处理 sdmode 参数
//     if (!sdmode) {
//         // 没有 sdmode 参数，无论在任何页面，跳转到 /home 并携带原有参数
//         if (to.path !== '/home') {
//             next({
//                 path: '/home',
//                 query: to.query,
//             });
//         } else {
//             next();
//         }
//         return;
//     } else if (sdmode !== '2') {
//         // sdmode 不等于 2，跳转到 /home 并携带原有参数
//         if (to.path !== '/home') {
//             next({
//                 path: '/home',
//                 query: to.query,
//             });
//         } else {
//             next();
//         }
//         return;
//     } else {
//         // sdmode 等于 2，确保每次跳转都携带 sdmode=2
//         if (!to.query.sdmode || to.query.sdmode !== '2') {
//             next({
//                 path: to.path,
//                 query: { ...to.query, sdmode: '2' },
//             });
//             return;
//         }
//     }

//     // 2. 继续原有逻辑：白名单、登录校验等
//     if (isIgnoreRoute) {
//         // 白名单路由，直接放行
//         next();
//     } else if (isLogin) {
//         // 已登录，放行
//         next();
//     } else {
//         // 未登录，跳转到登录页并携带原有参数
//         next({
//             path: '/login',
//             query: to.query,
//         });
//     }
// });

// 路由错误处理
router.onError(() => {
    console.log('router error');
    window.location.reload();
});

export default router;
